<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span>Copyright &copy; {{ new Date().getFullYear() }} <a href="https://stadiumcasablanca.com/" target="_blank" rel="nofollow">Stadium Casablanca</a>, All rights Reserved - <a href="http://www.stadiumcasablanca.com/aviso-legal/" target="_blank">Aviso legal</a> - <a href="https://stadiumcasablanca.com/terminos-de-uso/" target="_blank">Términos y condiciones</a> - <a href="https://stadiumcasablanca.com/politica-de-privacidad-club-deportivo-stadium-casablanca/" target="_blank">Política de privacidad</a></span>
        <!--span class="md:flex hidden items-center">
            <span>Hand-crafted & Made with</span>
            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
        </span-->

    </footer>
</template>

<script>

export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    },
    inject: {
      components:{
          default: {
          }
      }
    }
}
</script>
